import { render, staticRenderFns } from "./habitHomeStar.vue?vue&type=template&id=faafc2da&scoped=true"
import script from "./habitHomeStar.vue?vue&type=script&lang=js"
export * from "./habitHomeStar.vue?vue&type=script&lang=js"
import style0 from "./habitHomeStar.vue?vue&type=style&index=0&id=faafc2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faafc2da",
  null
  
)

export default component.exports